module.exports = __webpack_public_path__ + "img/export.c697edf8.svg";